
import {
  Component,
  Prop,
  PropSync,
  Watch,
  Mixins,
} from "vue-property-decorator";
import Breadcrumbs from "@/components/Base/Breadcrumbs/Breadcrumbs.vue";

import BreadcrumbsMixin from "@/mixins/BreadcrumbsMixin";
import CardListDetailNavigationOptions from "@/interfaces/Base/CardListDetail/CardListDetailNavigationOption";

@Component({ components: { Breadcrumbs } })
export default class BaseDetailCard extends Mixins(BreadcrumbsMixin) {
  @Prop({ required: false, default: "" })
  title!: string;

  @Prop({ required: false, default: false })
  loading!: boolean;

  @Prop({ required: false })
  navigationOptions!: CardListDetailNavigationOptions;

  @Prop({ required: false, default: false })
  noNavigationOptions!: boolean;

  @PropSync("selectedItem", { default: Object })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  selectedItemSync!: any | null;

  mounted() {
    this.resetToFirstLayer();
  }

  closeCard(): void {
    this.selectedItemSync = null;
  }

  navigationOptionClicked(layerName: string): void {
    this.breadcrumbs.push(layerName);
  }

  get currentLayerNavigationOptions(): string[] {
    if (this.noNavigationOptions) return [];

    if (this.selectedLayer === this.navigationOptions.name) {
      return this.navigationOptions.navigationOptions === null
        ? []
        : this.navigationOptions.navigationOptions
            .filter((x) => !x.handleNavigationManually)
            .map((y) => y.name);
    } else {
      const currentOptions = this.getCurrentLayerNavigatioOptions(
        this.selectedLayer,
        this.navigationOptions.navigationOptions
      );

      return currentOptions === null ||
        currentOptions.navigationOptions === null ||
        currentOptions.navigationOptions === undefined
        ? []
        : currentOptions.navigationOptions
            .filter((x) => !x.handleNavigationManually)
            .map((y) => y.name);
    }
  }

  private getCurrentLayerNavigatioOptions(
    currentLayerName: string,
    options: CardListDetailNavigationOptions[] | null
  ): CardListDetailNavigationOptions | null {
    if (!options) return null;

    for (let i = 0; i < options.length; i++) {
      if (options[i].name === currentLayerName) {
        return options[i];
      } else {
        const result = this.getCurrentLayerNavigatioOptions(
          currentLayerName,
          options[i].navigationOptions
        );

        if (result && result.navigationOptions !== null) {
          return result;
        }
      }
    }

    return null;
  }

  private resetToFirstLayer(): void {
    this.breadcrumbs = [];
    if (this.navigationOptions) {
      this.breadcrumbs.push(this.navigationOptions.name);
    }
  }

  @Watch("selectedLayer")
  breadcrumbsSelectedLayerChanged() {
    this.$emit("update:selectedLayer", this.selectedLayer);
  }

  @Watch("selectedItemSync")
  selectedItemChanged() {
    this.resetToFirstLayer();
  }

  //The below public functions allow for components using the card list detail detail card mixin to access functions in this base component

  public pushBreadcrumb(layer: string): void {
    this.breadcrumbs.push(layer);
  }
}
